import React from 'react';
import ScreenWrapper from '../../../commons/ScreenWrapper';
import MailTemplateForm from '../../../layouts/Admin/Plans/MailTemplateForm';

const MailTemplateEditPage = ({
    match,
    title,
    readOnly
}) => {
    const { offer_identifier } = match && match.params ? match.params : {};
    const [showSendTestMainBtn, setShowSendTestMainBtn] = React.useState(false)

    return (
        <ScreenWrapper
            pageTitle={title}
            hasForm
        >
            <MailTemplateForm match={match} readOnly={readOnly} offer_identifier={offer_identifier} showSendTestMainBtn={showSendTestMainBtn} setShowSendTestMainBtn={setShowSendTestMainBtn} />
        </ScreenWrapper>
    )
}

export default MailTemplateEditPage